import { getLocalizedOrDefault } from "../../../helpers/Functions";

const ProductTypeConfig = {
  collection: "product_types",
  fields: [
    "id",
    "name",
    "locale.label",
    "locale.language",
    "locale.languages_code.code"
  ],

  adapter: class ProductType {
    constructor(product_type) {
      this.id = product_type.id;
      this.name = product_type.name;

      let locale = product_type.locale?.[0];
      this.locale = product_type.locale;
      this.label = locale?.label;
    }
    map(collections, maps) {
      this.locale = this.locale.map(
        ({ languages_code, language, ...other_props }) => ({
          ...other_props,
          language:
            maps.languages?.[languages_code.code] || maps.locales?.[language]
        })
      );

      const { global_settings } = collections;
      const { default_locale } = global_settings;

      // e.g. field_name: header
      //      selected_locale: 'es-CL'
      this.getLocalized = (field_name, selected_locale) => {
        return getLocalizedOrDefault(
          this,
          field_name,
          { locale: selected_locale },
          {
            locale: default_locale.language || default_locale
          }
        );
      };
    }
  }
};

export default ProductTypeConfig;
